import styled from "styled-components";

// import colors from '../../constants/colors'
import breakpoints from "../../constants/breakpoints";
// import fonts from '../../constants/fonts'

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  padding: 4% 8%;
  height: 100%;
  align-items: center;
  background-color: rgba(245, 164, 98, 0.05);

  & > div {
    display: flex;
    width: 100%;
    flex-direction: row;
    margin: 0 0 32px 0;
    @media screen and (max-width: ${breakpoints.desktop.pixels}) {
      flex-direction: column;
    }
    & > div {
      display: flex;
      flex-direction: column;
      width: 50%;
      @media screen and (max-width: ${breakpoints.desktop.pixels}) {
        width: 100%;
        justify-content: center;
        align-items: center;
      }
      & > h1 {
        font-size: 16px;
        line-height: 26px;
        font-weight: 400;
      }
      & > div {
        display: flex;
        flex-direction: row;
        height: 100%;
        align-items: center;
        @media screen and (max-width: 600px) {
          flex-direction: column;
          max-width: 100vw;
          & > img {
            transform: scale(0.5);
          }
        }
      }
      & > div.primo {
        display: flex;
        flex-direction: row;
        height: 100%;
        align-items: center;
        @media screen and (max-width: 600px) {
          flex-direction: row;
          max-width: 100vw;
          margin-right: 24px;
          & > span {
            width: 8px;
          }
          & > img {
            transform: scale(0.5);
          }
        }
      }
    }
  }
  & p {
    font-size: 11px;
    line-height: 19px;
    font-weight: 200;
    color: #aeaeae;
  }
`;

export const Space = styled.span`
  width: 100px;
`;
